import { CUSTOMER, SELECT } from './filterTypes';

/* The Portal Users list (GET /portal-users through useApi's listPortalUsers). Each name is the
   query parameter portalUserQuery sends: q, role, status and customerId filter, and name, email,
   role and added sort. */
export const portalUserItemData = {
  fullName: {
    display: true,
    search: {
      name: 'q',
      label: 'Name or e-mail',
      // The server matches q anywhere in the name or e-mail itself, so the term goes as typed, without SQL wildcards.
      transformField: ({ field, value }) => (typeof value === 'string' && value.trim() ? { field, value: value.trim(), operator: 'ilike' } : null),
    },
    sort: {
      name: 'name',
      label: 'Name',
      initial: { field: 'name', by: 'ASC' },
      // The initial sort's direction is read from here; without it the list would open Z to A.
      by: 'ASC',
    },
    type: 'string',
  },
  email: {
    display: true,
    sort: {
      name: 'email',
      label: 'E-mail',
    },
    type: 'string',
  },
  role: {
    display: true,
    filter: {
      order: 0,
      type: SELECT,
      name: 'role',
      label: 'Role',
      defaults: { value: null },
      options: {
        any: { label: 'Any', name: 'any', value: null, fieldValue: null },
        customer: { label: 'Customer', name: 'customer', value: 'ndi:customer' },
        broker: { label: 'Broker', name: 'broker', value: 'ndi:broker' },
      },
    },
    sort: {
      name: 'role',
      label: 'Role',
    },
    type: 'string',
  },
  status: {
    display: true,
    filter: {
      order: 1,
      initial: { field: 'status', value: 'active', operator: 'equals' },
      defaults: { value: null },
      type: SELECT,
      name: 'status',
      label: 'Status',
      options: {
        all: { label: 'All', name: 'all', value: null, fieldValue: null },
        active: { label: 'Active', name: 'active', value: 'active' },
        no_access: { label: 'No access', name: 'no_access', value: 'no_access' },
      },
    },
    type: 'string',
  },
  customers: {
    display: true,
    filter: {
      order: 2,
      type: CUSTOMER,
      name: 'customerId',
      label: 'Customer',
    },
    type: 'array',
  },
  firstGrantedAt: {
    display: true,
    sort: {
      name: 'added',
      label: 'Added',
    },
    type: 'string',
  },
};
